"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const math_1 = require("../utils/math");
function updateBestScore(aggregatedStat, sessionEvent) {
    const { session } = sessionEvent;
    return (0, math_1.getMaximumValue)(aggregatedStat.bestScore, session.sessionScore);
}
exports.default = updateBestScore;
